import {useCallback} from 'react';

import {useIsInLoadedReportContext} from '../../../pages/ReportPage/LoadedReportContext';
import history from '../../../util/history';
import {usePanelContext} from '../PanelContextProvider';
import {useSharePanelLink} from '../StandalonePanel';
import {PanelPopupMode} from '../types';

export const useOpenPanelEditor = () => {
  const isReport = useIsInLoadedReportContext();
  const {panel, setPanelPopupMode} = usePanelContext();

  const sharePanelLink = useSharePanelLink();

  const openPanelEditor = useCallback(() => {
    const searchParams = new URLSearchParams(window.location.search);
    if (isReport) {
      searchParams.set('panelId', panel.__id__);
      const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
      history.push(newUrl);
      setPanelPopupMode(PanelPopupMode.FULL_SCREEN);
      return;
    }
    history.push(sharePanelLink());
    window.scrollTo(0, 0); // Prevent panels opened from lower in the workspace from appearing partially scrolled out of view.
  }, [panel.__id__, setPanelPopupMode, isReport, sharePanelLink]);

  return openPanelEditor;
};
